import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import CreateNonTeachingStaff from './routes/CreateNonTeachingStaff';
import EditNonTeachingStaff from './routes/EditNonTeachingStaff';

const NonTeachingStaffLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'NonTeachingStaff' */ './components/NonTeachingStaff'
		)
);

export default (store) => {
	return [
		{
			path: 'nonteaching-staff',
			element: (
				<AsyncLoading
					component={
						<NonTeachingStaffLazy featureFlag="FeatureFlag:TransportModule" />
					}
				/>
			),
		},
		CreateNonTeachingStaff(store),
		EditNonTeachingStaff(store),
	];
};
